import React, { useEffect, useState } from 'react';
import { NavLink, Link } from 'react-router-dom';

import constants from '../lib/constants';
import api from '../utils/api';
import Loader from '../lib/components/Loader';


const Draft = ({ playerData, outgoingPicks }) => {   
    const FullDraft = ({ year }) => {
        const [draftOrder, updateDraftOrder] = useState(null);
        const [isProjected, updateIsProjected] = useState(true);
        const [loading, updateLoading] = useState(false);
        const [error, updateError] = useState(false);
    
        useEffect(() => {
            updateLoading(true);
            api.get(`/api/v1/draft/${year}/order`).then(({ data: {order, isProjected} }) => {
                updateDraftOrder(order);
                updateIsProjected(isProjected);
            }).catch(res => {
                console.error(res);
                updateError(true);
            }).finally(() => {
                updateLoading(false);
            })
        }, [year]);
    
        if (loading) {
            return <Loader/>;
        }
    
        if (error || !draftOrder) {
            return <div>Something went wrong loading draft order!</div>;
        }
    
        // picks
        const numYearsInFuture = year - constants.currentSeason,
            draftPlayers = playerData.filter(player => player.contract === numYearsInFuture),
            fullDraft = [];
    
        fullDraft.push.apply(fullDraft, draftOrder); // 1
        fullDraft.push.apply(fullDraft, draftOrder); // 2
        fullDraft.push.apply(fullDraft, draftOrder); // 3
        fullDraft.push.apply(fullDraft, draftOrder); // 4
        fullDraft.push.apply(fullDraft, draftOrder); // 5
        fullDraft.push.apply(fullDraft, draftOrder); // 6
        fullDraft.push.apply(fullDraft, draftOrder); // 7
    
        return (
            <div className="sectionContainer">
                <h3>{year} Draft</h3>
                <div>
                    <h4>Draft Picks</h4>
                    <div className="d-grid mx-auto">
                        <button className="btn btn-outline-info draft-accordion-btn" type="button" data-bs-toggle="collapse" data-bs-target={'#draft-table' + year} aria-expanded="false" aria-controls={'draft-table' + year}>
                            <i className="bi bi-chevron-down me-2"></i>
                            Show/Hide Draft Order
                            <i className="bi bi-list-ul ms-2"></i>
                        </button>
                    </div>
                    <div className="collapse" id={'draft-table' + year}>
                        <table className="table table-dark table-bordered table-striped caption-top">
                            {isProjected && <caption>*Projected Order</caption>}
                            <thead>
                                <tr>
                                    <th scope="col">#</th>
                                    <th scope="col" style={{}}>Manager</th>
                                </tr>
                            </thead>
                            <tbody>
                                {fullDraft.map((manager, index) => {
                                    // let origPickManager = draftData.order[index % 12]
                                    let roundNumber = Math.floor(index/12),
                                        newPickOwner;
    
                                    //find if traded pick
                                    if (outgoingPicks[manager] && outgoingPicks[manager][year]) {
                                        newPickOwner = outgoingPicks[manager][year][roundNumber + 1];
                                    }
                                    return (
                                        <tr key={manager + index} style={{lineHeight: .5}}>
                                            <th scope="row">{roundNumber + 1}.{index + 1}</th>
                                            <td style={{}}>{manager} {newPickOwner ? <span style={{fontWeight: "bold"}}>({newPickOwner})</span> : ''}</td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div>
                    <h4>Available Players</h4>
                    <table className="table table-dark table-bordered table-striped">
                        <thead>
                            <tr>
                                <th scope="col">Rank</th>
                                <th scope="col">Player</th>
                                <th scope="col" style={{textAlign: "right"}}>Can Tag?</th>
                            </tr>
                        </thead>
                        <tbody>
                            {draftPlayers.map((player, index) => {
                                let canTag = player.manager && !player.franchisetag;
                                return (
                                    <tr key={player + index} style={{lineHeight: .5}} className={canTag ? 'tag-eligible-row' : ''}>
                                        <th scope="row">{index + 1}</th>
                                        <td><Link to={`/player/${player.id}`}>{player.name}</Link> | {player.posname}</td>
                                        <td style={{textAlign: "right"}}>{canTag ? player.manager : '-'}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        )
    };
    return (
        <div id="DraftPageContainer">
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h2>Draft Central</h2>
                <NavLink to="/history" className="btn btn-outline-primary">
                    View Past Drafts
                    <i className="bi bi-chevron-right ms-2"></i>
                </NavLink>
            </div>
            <FullDraft year={2027}/>
            <FullDraft year={2028}/>
        </div>
    );
}

export default Draft;